import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { useSelector } from "react-redux";
import { useTranslator } from "../../context/translator";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const Nav = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [companyAllow, setCompanyAllow] = useState([]);
  const { translate } = useTranslator();

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  const isOptionsSelected = (option) => {
    const url = window.location.pathname;
    if (option !== "/" && url.includes(option)) {
      return "block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500";
    } else if (option === url) {
      return "block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500";
    }
    return "block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700";
  };

  const handleSignOut = () => {
    return navigate(`/sign-out`);
  };

  useEffect(() => {
    // Update the allow state when company changes
    if (company && company?.allow) {
      setCompanyAllow({ ...company?.allow });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  if (userLoading || companyLoading) return null;

  return (
    <nav className="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
          <img src="/logo-OB.svg" className="h-8" alt="GCM Logo"></img>
          <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            GCM
          </span>
        </a>
        <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
          <button
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            onClick={handleSignOut}
          >
            {translate("signout")}
          </button>
          <button
            data-collapse-toggle="navbar-sticky"
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-sticky"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
        </div>
        <div
          className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
          id="navbar-sticky"
        >
          <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
            <li>
              <a
                href="/"
                className={isOptionsSelected("/")}
                aria-current="page"
              >
                {translate("home")}
              </a>
            </li>
            <li>
              <a href="/team" className={isOptionsSelected("/team")}>
                {translate("team")}
              </a>
            </li>
            <li>
              <a href="/clients" className={isOptionsSelected("/clients")}>
                {IsAllow(companyAllow, "customer-02")
                  ? translate("shops")
                  : translate("customers")}
              </a>
            </li>
            {IsAllow(companyAllow, "campaigns") && (
              <li className="">
                <a
                  href="/campaigns"
                  className={isOptionsSelected("/campaigns")}
                >
                  {translate("campaigns")}
                </a>
              </li>
            )}
            {IsAllow(companyAllow, "report-01") && (
              <li className="">
                <a
                  href="/report/customer-report"
                  className={isOptionsSelected("report/customer-report")}
                >
                  {translate("reports")}
                </a>
              </li>
            )}
            <li className="">
              <a href="/settings" className={isOptionsSelected("/settings")}>
                {translate("settings")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
